import { createBrowserRouter } from 'react-router';
import { PATHS } from '../shared/routing/paths.ts';
import { PageSkeleton } from '../shared/ui/index.ts';
import { RouteErrorBoundary } from './RouteErrorBoundary.tsx';

/**
 * Route table. Every page is a lazily loaded chunk, so the invite/room bundle (player, call) never
 * slows down the studio and vice versa.
 */
export const createAppRouter = () =>
  createBrowserRouter([
    {
      errorElement: <RouteErrorBoundary />,
      HydrateFallback: PageSkeleton,
      children: [
        {
          path: PATHS.home,
          lazy: async () => ({ Component: (await import('../pages/HomePage.tsx')).HomePage }),
        },
        {
          path: PATHS.login,
          lazy: async () => ({ Component: (await import('../pages/LoginPage.tsx')).LoginPage }),
        },
        {
          path: PATHS.welcome,
          lazy: async () => ({ Component: (await import('../pages/WelcomePage.tsx')).WelcomePage }),
        },
        {
          path: PATHS.studio,
          lazy: async () => ({ Component: (await import('../pages/studio/StudioPage.tsx')).StudioPage }),
          children: [
            {
              index: true,
              lazy: async () => ({
                Component: (await import('../pages/studio/ScreeningsPage.tsx')).ScreeningsPage,
              }),
            },
            {
              path: PATHS.library,
              lazy: async () => ({
                Component: (await import('../pages/studio/LibraryPage.tsx')).LibraryPage,
              }),
            },
            {
              path: PATHS.asset,
              lazy: async () => ({ Component: (await import('../pages/studio/AssetPage.tsx')).AssetPage }),
            },
            {
              path: PATHS.hosts,
              lazy: async () => ({ Component: (await import('../pages/studio/HostsPage.tsx')).HostsPage }),
            },
          ],
        },
        {
          path: PATHS.invite,
          lazy: async () => ({ Component: (await import('../pages/InvitePage.tsx')).InvitePage }),
        },
        {
          path: '*',
          lazy: async () => ({ Component: (await import('../pages/NotFoundPage.tsx')).NotFoundPage }),
        },
      ],
    },
  ]);
